import { get } from "lodash";

const getIsLoading = state =>
  get(state, "debtor.loading", false) ||
  get(state, "debtor.payments.loading", false);

export default getIsLoading;
